import { ApiCallState, ToastType } from '../constants';
import { addToastByActionName, addError } from '../actions';
import { getAnyError } from '../helpers/get-error';
import { SERVER_ERROR_ACTION_NAME } from '../constants/other';
const TYPES = {
    [ApiCallState.success]: ToastType.success,
    [ApiCallState.error]: ToastType.error,
};
const requestMiddleware = (store) => (next) => (action) => {
    if (action && action.type) {
        const matches = new RegExp(`(.*)_(${ApiCallState.success}|${ApiCallState.error})`).exec(action.type);
        if (matches && action.payload) {
            const [, actionTypeName, requestState] = matches;
            const { requestId, error, toast, shouldStoreError } = action.payload;
            if (requestState === ApiCallState.success && toast) {
                const { type, actionName, message } = toast;
                store.dispatch(addToastByActionName(type || TYPES[requestState], actionName || SERVER_ERROR_ACTION_NAME, message));
            }
            if (requestState === ApiCallState.error) {
                const err = getAnyError(error);
                if (toast) {
                    const { type, actionName, message } = toast;
                    const msg = (err && err.message) || message;
                    store.dispatch(addToastByActionName(type || TYPES[requestState], actionName || SERVER_ERROR_ACTION_NAME, msg));
                }
                if (shouldStoreError && err) {
                    store.dispatch(addError(requestId || actionTypeName, err));
                }
            }
        }
    }
    next(action);
};
export default requestMiddleware;
